"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoTeaser = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useVideoModal = require("b2b-components/hooks/useVideoModal");
var _Teaser = require("b2b-components/theme/components/CMS/Teaser");
var _Modal = require("b2b-components/theme/components/Modal");
var _Video = require("b2b-components/theme/components/Video");
var _VideoPlay = require("b2b-components/theme/components/VideoPlay");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./VideoTeaser.scss");
const VideoTeaser = _ref => {
  let {
    buttonLabel,
    className,
    content,
    contentPosition,
    imageUrl,
    logoUrl,
    logoPosition,
    onClick,
    styleType,
    title,
    type,
    url,
    videoUrl,
    dataAttributes
  } = _ref;
  const {
    isVideoModalOpened,
    onVideoModalClose,
    onVideoPlayClick
  } = (0, _useVideoModal.useVideoModal)();
  const rootClassName = (0, _classnames.default)('cds-VideoTeaser', {
    'cds-VideoTeaser--Size66': type === _Teaser.TEASER_TYPE.size66,
    'cds-VideoTeaser--Size50': type === _Teaser.TEASER_TYPE.size50,
    'cds-VideoTeaser--Size33': type === _Teaser.TEASER_TYPE.size33
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement(_Teaser.Teaser, {
    buttonLabel: buttonLabel,
    content: content,
    contentPosition: contentPosition,
    imageUrl: imageUrl,
    logoUrl: logoUrl,
    logoPosition: logoPosition,
    onClick: onClick,
    styleType: styleType,
    title: title,
    type: type,
    url: url
  }), /*#__PURE__*/_react.default.createElement(_VideoPlay.VideoPlay, {
    onClick: onVideoPlayClick
  }), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    isOpen: isVideoModalOpened,
    onCloseModal: onVideoModalClose,
    content: () => /*#__PURE__*/_react.default.createElement(_Video.Video, {
      title: title,
      videoUrl: videoUrl
    }),
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.VideoTeaser = VideoTeaser;
//# sourceMappingURL=VideoTeaser.js.map